import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Experiences from './pages/Experiences';
import ExperienceDetail from './pages/ExperienceDetail';
import Webhooks from './pages/Webhooks';
import Storage from './pages/Storage';

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Dashboard />} />
        <Route path="experiences" element={<Experiences />} />
        <Route path="experiences/:id" element={<ExperienceDetail />} />
        <Route path="webhooks" element={<Webhooks />} />
        <Route path="storage" element={<Storage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
